import React from 'react';
import { PageContainer } from '@amzn/atoz-web/PageContainer';
import { Flex } from '@amzn/atoz-web/Flex';
import { Col } from '@amzn/atoz-web/Col';
import { Text } from '@amzn/atoz-web/Text';
import { useBreakpoints } from '@amzn/atoz-web/Responsive';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
export var SchedulePageLayout = function (_a) {
    var pageHeader = _a.pageHeader, calendarToggle = _a.calendarToggle, calendarView = _a.calendarView, shiftFeatures = _a.shiftFeatures, selectedDate = _a.selectedDate, weeklySummaryFeature = _a.weeklySummaryFeature, punchFeature = _a.punchFeature, hourlyBreakdownFeature = _a.hourlyBreakdownFeature;
    var matches = useBreakpoints().matches;
    return (React.createElement(PageContainer, { dataTestId: "SchedulePageLayout" },
        pageHeader,
        React.createElement(Col, { gridGap: "S500" },
            weeklySummaryFeature && (React.createElement(Col, { dataTestId: "SchedulePageLayout__WeeklySummaryFeatureWrapper" }, weeklySummaryFeature)),
            React.createElement(ScheduleWrapper, { gridGap: "S300", flexDirection: matches.s ? 'column' : 'row' },
                React.createElement(Col, { flex: 1, "data-testid": "SchedulePageLayout-ScheduleCalendarView", className: calendarToggle ? 'dual-cal-container' : '' },
                    calendarToggle,
                    React.createElement(Col, { className: calendarToggle ? 'dual-cal-view' : '' }, calendarView)),
                React.createElement(Col, { flex: 1, gridGap: "S300", "data-testid": "SchedulePageLayout-ShiftFeatures" },
                    React.createElement(Text, { fontSize: "T400" }, selectedDate.toFormat('EEEE, MMM dd')),
                    punchFeature,
                    shiftFeatures,
                    hourlyBreakdownFeature)))));
};
var ScheduleWrapper = styledWithTheme(Flex)(function (_a) {
    var theme = _a.theme;
    return "\n        .dual-cal-container{\n            gap: ".concat(theme.selectors.space('S300'), "px;\n        }\n    \n        .dual-cal-view{\n            background-color: ").concat(theme.selectors.color('neutral0'), ";\n            padding: ").concat(theme.selectors.space('S300'), "px;\n        }\n    ");
});
